import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://eysgxdfuajwbxakgphke.supabase.co";
const SUPABASE_PUBLIC_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV5c2d4ZGZ1YWp3Ynhha2dwaGtlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTI3NDA0MzQsImV4cCI6MjAyODMxNjQzNH0.3pPwWXJlhJzxedUsYEtKkfuoDSZj29A7Yt4_F_NY5HA";

// 在您的Supabase控制台中找到您的Supabase URL和匿名公钥，并替换下面的值
export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLIC_KEY);
